import { useState, useEffect, useRef } from "react";

function Reader({ book, chapter }) {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [zoom, setZoom] = useState(1);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const touchStartX = useRef(null);

  const BASE_URL =
    process.env.REACT_APP_API_URL ||
    window.location.origin;

  // 📷 Image path (supports multiple books)
 // const getImage = (p) =>
  //  `${BASE_URL}/books/${book}/chapter${chapter}/${p}.jpeg`;
const getImage = (p) =>
  `${BASE_URL}/books/${book}/chapter${chapter}/${p}.jpeg?t=${Date.now()}`;
  // 📊 Fetch total pages (book + chapter aware)
  /*
  useEffect(() => {
    const fetchPages = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/api/chapter/${book}/${chapter}`
      //    fetch(`${BASE_URL}/api/chapter/${book}/${chapter}`)
        );
        const data = await res.json();
        setTotalPages(data.totalPages || 1);
      } catch (err) {
        console.error("Failed to fetch page count", err);
        setTotalPages(1);
      }
    };

    fetchPages();
  }, [book, chapter]);
  */
//
useEffect(() => {
  const fetchPages = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/api/chapter/${book}/${chapter}`
      );
if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
      const data = await res.json();

      setTotalPages(data.totalPages || 50);
    } catch (err) {
      console.error("Failed to fetch page count", err);
      setTotalPages(50);
    }
  };

  fetchPages();
}, [book, chapter]);

//
  // 🔖 Load bookmark
  useEffect(() => {
    const saved = localStorage.getItem(
      `bookmark-${book}-ch${chapter}`
    );

    if (saved && Number(saved) > 0) {
      setPage(Number(saved));
    } else {
      setPage(1);
    }
  }, [book, chapter]);

  // 💾 Save bookmark
  useEffect(() => {
    localStorage.setItem(
      `bookmark-${book}-ch${chapter}`,
      page
    );
  }, [page, book, chapter]);

  // ⌨️ Keyboard navigation
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextPage();
      if (e.key === "ArrowLeft") prevPage();
    };

    window.addEventListener("keydown", handleKey);
    return () =>
      window.removeEventListener("keydown", handleKey);
  }, [page, totalPages]);

  // 👉 Next / Prev
  const nextPage = () => {
    setPage((p) => Math.min(p + 1, totalPages));
  };

  const prevPage = () => {
    setPage((p) => Math.max(p - 1, 1));
  };

  // 📱 Swipe support
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff =
      e.changedTouches[0].clientX - touchStartX.current;

    if (diff > 50) prevPage();
    if (diff < -50) nextPage();
  };

  // 🔍 Zoom controls
  const zoomIn = () => setZoom((z) => Math.min(z + 0.1, 2.5));
  const zoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
  const resetZoom = () => setZoom(1);

  // ⛶ Fullscreen toggle
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        📖 {book} | Chapter {chapter}
      </h2>

      {/* IMAGE VIEWER */}
      <div
        style={styles.pageWrapper}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onDoubleClick={toggleFullScreen}
      >
        <img
          key={`${book}-${chapter}-${page}`}
          src={getImage(page)}
          alt={`page-${page}`}
          style={{
            ...styles.image,
            transform: `scale(${zoom})`,
            transition: "transform 0.2s ease",
          }}
        />
      </div>

      {/* NAVIGATION */}
      <div style={styles.controls}>
        <button
          onClick={prevPage}
          disabled={page === 1}
          style={styles.btn}
        >
          ⬅ Prev
        </button>

        <span style={styles.pageText}>
          Page {page} / {totalPages}
        </span>

        <button
          onClick={nextPage}
          disabled={page === totalPages}
          style={styles.btn}
        >
          Next ➡
        </button>
      </div>

      {/* ZOOM + FULLSCREEN CONTROLS */}
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <button onClick={zoomOut} style={styles.btn}>
          ➖ Zoom
        </button>

        <button onClick={resetZoom} style={styles.btn}>
          🔄 Reset
        </button>

        <button onClick={zoomIn} style={styles.btn}>
          ➕ Zoom
        </button>

        <button onClick={toggleFullScreen} style={styles.btn}>
          {isFullScreen ? "🪟 Exit Full" : "⛶ Full Screen"}
        </button>
      </div>

      {/* BOOKMARK */}
      <div style={styles.bookmark}>
        🔖 Auto-saved page {page}
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    background: "#111",
    color: "#fff",
    minHeight: "100vh",
    padding: "20px",
  },
  header: {
    marginBottom: "10px",
  },
  pageWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "75vh",
    overflow: "hidden",
    cursor: "grab",
  },
  image: {
    maxWidth: "90%",
    maxHeight: "100%",
    objectFit: "contain",
    borderRadius: "10px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
  },
  controls: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginTop: "10px",
  },
  btn: {
    padding: "10px 20px",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
  },
  pageText: {
    fontWeight: "bold",
  },
  bookmark: {
    marginTop: "10px",
    fontSize: "12px",
    opacity: 0.7,
  },
};

export default Reader;